"use client";

import React from "react";
import { ButtonStyleType, SpacingType } from "@/types";
import { sectionVariants } from "@/types";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import parse from "html-react-parser";
import { SectionWrapper } from "../components/SectionWraper";
import { Badge } from "../ui/badge";
import { Globe } from "@/components/magicui/globe";


interface Feature23Props { 
  darkMode?: boolean; 
  variant?: sectionVariants;
  spacing?: SpacingType;
  usedInPageNav?: boolean;
  pageNavTitle?: string;
  themeChangeOnScroll?: boolean;
  badge?: string;
  title?: string;
  content?: string;
  hasButton?: boolean;
  buttonText?: string;
  buttonLink?: string;
  buttonStyle?: ButtonStyleType;
  microCopy?: string;
  secondaryButton?: boolean;
  secondaryButtonText?: string;
  secondaryButtonLink?: string;
  secondaryButtonStyle?: ButtonStyleType;
  attributes?: React.HTMLProps<HTMLElement>;
}

const Feature23 = ({
  darkMode = false,
  variant = "A",
  spacing,
  usedInPageNav = false,
  pageNavTitle = "Feature 24",
  themeChangeOnScroll = false,
  badge,
  title,
  content,
  hasButton,
  buttonText,
  buttonLink,
  buttonStyle,
  microCopy,
  secondaryButton,
  secondaryButtonText,
  secondaryButtonLink,
  secondaryButtonStyle,
  attributes,
}: Feature23Props) => {

  return (
    <SectionWrapper
      usedInPageNav={usedInPageNav}
      pageNavTitle={pageNavTitle}
      themeChangeOnScroll={themeChangeOnScroll}
      removePaddingBottom={true}
      spacing={spacing}
      variant={variant}
      darkMode={darkMode}
      heroSection={false}
      componentName="feature23"
      attributes={attributes}
    >

      <div className="container">
        <div className="flex flex-col justify-between gap-6 items-center text-center max-w-3xl mx-auto" data-aos="fade-up">
          {title && (
            <> 
              {badge && (
                <Badge variant="outline" bold>
                  {badge}
                </Badge>
              )}
              <h2>
                {parse(title)}
              </h2>
            </>
          )}
          {(content || hasButton) && (
            <>  
              {content && (
                <div className="text-muted-foreground">
                  {parse(content)}
                </div>
              )}
              {hasButton && (
                <div className="flex flex-col md:flex-row gap-4 w-full justify-center">
                  <div className="flex flex-col">
                    <Button asChild variant={buttonStyle} size="lg" className="w-full sm:w-auto">
                      <Link href={buttonLink ?? ""}>
                        {buttonText}
                      </Link>
                    </Button>
                    {microCopy && (
                      <p className="paragraph-sm text-muted-foreground text-center mt-3">
                        {microCopy}
                      </p>
                    )}
                  </div>
                  {secondaryButton && (
                    <Button asChild variant={secondaryButtonStyle} size="lg" className="w-full sm:w-auto">
                      <Link href={secondaryButtonLink ?? ""}>
                        {secondaryButtonText}
                      </Link>
                    </Button>
                  )}
                </div>
              )}
            </>
          )}
        </div>
      </div>
      <div className="relative h-125 w-full overflow-hidden mt-0 lg:mt-20">
        <Globe 
          className="translate-y-40 scale-175" 
          darkMode={darkMode}
          variant={variant}
        />
      </div>
    </SectionWrapper>
  )
};

export { Feature23 };